import { respondTo } from '@/respondTo';
import Styled from 'styled-components';

export const CardInnerContainer = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1.25rem;
    overflow-y: scroll;
   

    ${respondTo.desktop`
    overflow-y: unset;
    background-color: var(--background-light);
    display:block;
    position: relative;
    max-width: 1512px;
    `}

    &::-webkit-scrollbar {
        display: none;
    }
  `;

export const AnimationSection = Styled.div <{offset: number , windowHeight:number }>`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 1.25rem;
height: 100%;

${respondTo.tablet_landscape_s`
    inset: 0px auto auto 0px;
    margin: 1.5rem auto 0;
    max-width: 1024px;
    width: 1024px;
    `}



${respondTo.desktop`
    display: block;
    height:3000px;
    inset: 0px auto auto 0px;
    margin: 1.5rem auto 0;
    max-height:3000px;
    max-width: 1194px;
    position: sticky;
    top: 0px;
    transform: ${({offset, windowHeight, idx} : any) =>  `translate( 0px ,${((offset/60 ))}px)`};
    width: 1194px;
    `}

${respondTo.desktop_xl`
      height: 3200px;
      max-height: 3200px;
      max-width: 1512px;
      width: 1512px;
      `}
 ${respondTo.desktop_xxl`
        height: 4000px;
        max-height: 4000px;
 ` }

    `;


export const CardBox = Styled.div<{offset: number , idx: number , windowHeight : number}>`
    background-color: var(--on-primary-dark);
    display: flex;
    flex-direction: column;
    width: 100%;
    

    ${respondTo.tablet_landscape_s`
    align-items: center;
    background-color: var(--on-primary-dark);
    flex-direction: row;
    justify-content: space-between;
    margin: 0rem auto 2rem;
    width: 944px;
    height: ${({windowHeight}:any ) => `calc(${windowHeight}px - 30vh)`};
    padding: 1.25rem ;
    `}



${respondTo.desktop`
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin: 0rem auto 4rem;
    width: 1114px;
    height: ${({windowHeight}:any ) => `calc(${windowHeight}px - 30vh)`};
    max-height: 45rem;
    padding: 1.25rem ;
    position : sticky;
    top: ${({idx}:any) => idx === 0 ? '8vh' : ` calc(8vh + ${idx * 42}px)`};
    z-index: -1;
    transition: all 0.3s;
    opacity: ${({offset, windowHeight , idx} : any) =>
    idx === 1?
        offset < windowHeight/1.5 && idx != 4 ? (offset/600): 1 :
    idx === 2?
        offset <  windowHeight/1.7  && idx != 4 ? (offset/600): 1 :
    idx === 3?
        offset < windowHeight/1.9  && idx != 4 ? (offset/600): 1 :
    idx === 4? 1 : 1};  
    
    transform: ${({offset, windowHeight, idx} : any) => 
        idx === 1?
            offset < windowHeight? `scale(max(${(offset/80000) + 0.95}, 0.95 )) translateZ(0) ` : 'scale(0.96) translateZ(0)' :  
        idx === 2?
            offset < windowHeight? `scale(max(${(offset/80000) + 0.96}, 0.96 )) translateZ(0) ` : 'scale(0.97) translateZ(0)' :
        idx === 3?
            offset < windowHeight ? `scale(max(${(offset/80000) + 0.98}, 0.98 )) translateZ(0) ` : 'scale(1) translateZ(0)' :
        idx === 4? 
            'scale(1) translateZ(0)' : 'scale(1) translateZ(0)'};
    `}

    ${respondTo.desktop_xl`
    width: 1372px;
    `}






`;

//  transform: ${({offset, windowHeight, idx} : any) => offset < (windowHeight/1.3) ? `scale(max(${(offset/60000 * idx ) + 0.96},0.96)) translateZ(0)` : 'scale(1) translateZ(0)'};

export const NumSelectors = Styled.div <{offset?: number , idx?: number , windowHeight? : number , lastStep?:number}>`
    display: none;
    ${respondTo.desktop`
        display: flex;
        padding: 0 0.625rem;
    `}
    z-index: 100;
`;


export const ImgContainer = Styled.div <{afterLine?: boolean}>`
    align-items: center;
    display: flex;
    height:18.75rem;
    justify-content: center;
    position: relative;

    img {
        height:12.5rem;
    }

    ${respondTo.tablet_landscape_s`
    height: 17.5rem;
    padding: 0 1.25rem;
    img {
        height: 17.5rem;
    }
    `}

    ${respondTo.desktop`
   
    margin-left: 2.5rem;
    img {
        height: 17.5rem;
    }
    `}
    `;

export const TextInnerContainer = Styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.625rem;
    max-width: 22.31rem;
    padding: 1.25rem 1.25rem 1.5rem;

    ${respondTo.tablet_landscape_s`
        max-width: 32.62rem;
        padding: 1.25rem 1.25rem 1.5rem;
    `}

    ${respondTo.desktop`
       max-width: 32.62rem;
       padding: 11.125rem 1.25rem;
    `}

    ${respondTo.desktop_xl`
        max-width: 48.75rem ;
        padding: 9.75rem 1.25rem;
    `}
`;

export const TextBox = Styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    justify-content: center;
    `;

export const CardTitle = Styled.h2`
    color: var(--on-background-dark);
`;

export const CardDescription = Styled.p`
   color: var(--on-background-dark);
   `;
export const SxBtn = {
    width: "unset !important" 
}

export const TextStartNow = Styled.p`
       color: var(--primary-dark);
`;

